import { useEffect } from "react"

import { handleArrowFieldNavigation } from "@/lib/formNavigation"

const ArrowFormNavigator = (): null => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.defaultPrevented) {
        return
      }
      handleArrowFieldNavigation(event)
    }

    document.addEventListener("keydown", handleKeyDown, { capture: true })

    return () => {
      document.removeEventListener("keydown", handleKeyDown, { capture: true })
    }
  }, [])

  return null
}

export default ArrowFormNavigator
